@let items = resolvedDisplaySg();
@let isLoading = isLoadingSg();

@for (item of items; track item) {
  <atn-ds-tag [text]="item" />
}
@if (!items.length && isLoading) {
  <span class="atn-reference-loading">…</span>
}
